export default {"src":"/uk/_next/static/media/laptopIcon.a76d8901.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};